<script setup>
import PageWrapper from '@/components/shared/page/PageWrapper.vue'
import PageSection from '@/components/shared/page/PageSection.vue'
</script>

<template>
  <PageWrapper
    is-transparent
    header="Experimental features"
  >
    <PageSection header="Some magical new feature we're testing will go here" />
  </PageWrapper>
</template>
